<template>
  <div style="margin: 10px">
    <div>
      <div style="margin-bottom: 5px; margin-top: 5px">
        <el-button @click="excelPost()">打印</el-button>
      </div>
    </div>
    <div class="cdj_div" style="margin-top: 20px">收费汇总表-查询条件</div>
    <el-descriptions
      :column="2"
      border
      size="mini"
      :labelStyle="{ width: '123px', color: 'black' }"
      :contentStyle="{ width: '42%' }"
    >
      <el-descriptions-item label="计费周期">
        <el-date-picker
          size="mini"
          v-model="startDate"
          type="date"
          format="yyyy-MM-dd"
          value-format="timestamp"
          placeholder="开始时间"
        ></el-date-picker>
        <span class="cdj_text_data">至</span>
        <el-date-picker
          size="mini"
          v-model="endDate"
          type="date"
          format="yyyy-MM-dd"
          value-format="timestamp"
          placeholder="结束时间"
        ></el-date-picker>
      </el-descriptions-item>
      <el-descriptions-item label="房产">
        <div style="display: flex">
          <div
            @click="houses"
            v-if="data.house"
            style="cursor: pointer; color: red"
            :class="data.house.length > 30 ? 'dade-text' : ''"
          >
            {{ data.house }}
          </div>
          <div
            @click="houses_del"
            v-if="data.house"
            style="cursor: pointer; margin-left: 10px"
          >
            取消选择
          </div>
          <div @click="houses" v-else style="cursor: pointer">选择房产...</div>
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="缴款周期">
        <el-date-picker
          size="mini"
          v-model="payStartDate"
          type="date"
          format="yyyy-MM-dd"
          value-format="timestamp"
          placeholder="开始时间"
        ></el-date-picker>
        <span class="cdj_text_data">至</span>
        <el-date-picker
          size="mini"
          v-model="payEndDate"
          type="date"
          format="yyyy-MM-dd"
          value-format="timestamp"
          placeholder="结束时间"
        ></el-date-picker>
      </el-descriptions-item>

      <el-descriptions-item label="客户">
        <div style="display: flex">
          <el-input
            style="width: 80%"
            v-model="data.user"
            placeholder="客户姓名"
          ></el-input>
          <el-button @click="user">选择客户</el-button>
        </div>
      </el-descriptions-item>

      <el-descriptions-item label="日结日期">
        <el-date-picker
          size="mini"
          v-model="dayPayStartDate"
          type="date"
          format="yyyy-MM-dd"
          value-format="timestamp"
          placeholder="开始时间"
        ></el-date-picker>
        <span class="cdj_text_data">至</span>
        <el-date-picker
          size="mini"
          v-model="dayPayEndDate"
          type="date"
          format="yyyy-MM-dd"
          value-format="timestamp"
          placeholder="结束时间"
        ></el-date-picker>
      </el-descriptions-item>

      <el-descriptions-item label="费用类型(默认主营)">
        <div style="display: flex">
          <div
            @click="chargeitems"
            v-if="data.chargeitemIDName"
            style="cursor: pointer; color: red"
            :class="data.chargeitemIDName.length > 30 ? 'dade-text' : ''"
          >
            {{ data.chargeitemIDName }}
          </div>
          <div
            @click="chargeitems_del"
            v-if="data.chargeitemIDName"
            style="cursor: pointer; margin-left: 10px"
          >
            取消选择
          </div>
          <div @click="chargeitems" v-else style="cursor: pointer">
            选择收费项目...
          </div>
        </div>
      </el-descriptions-item>

      <el-descriptions-item label="客户类型">
        <CheckboxGroup v-model="data.userType">
          <Checkbox label="1" style="font-weight: 500">业主</Checkbox>
          <Checkbox label="2" style="font-weight: 500">租户</Checkbox>
          <Checkbox label="3" style="font-weight: 500">住户</Checkbox>
          <Checkbox label="4" style="font-weight: 500">共有人</Checkbox>
          <Checkbox label="5" style="font-weight: 500">开发商</Checkbox>
          <Checkbox label="9" style="font-weight: 500">其它</Checkbox>
        </CheckboxGroup>
      </el-descriptions-item>
      <el-descriptions-item label="默认费用类型">
        <Space direction="vertical" size="large">
          <RadioGroup v-model="data.is_meter_charge">
            <Radio label="0" style="font-weight: 500">默认主营</Radio>
            <Radio label="1" style="font-weight: 500">默认能耗</Radio>
          </RadioGroup>
        </Space>
      </el-descriptions-item>

      <el-descriptions-item label="结算方式">
        <Space direction="vertical" size="large">
          <CheckboxGroup v-model="data.paymentId">
            <div style="display: flex; flex-wrap: wrap">
              <div v-for="it in payment" :key="it.id">
                <Checkbox :label="it.number">{{ it.name }}</Checkbox>
              </div>
            </div>
          </CheckboxGroup>
        </Space>
      </el-descriptions-item>

      <el-descriptions-item label="收费标准">
        <div style="display: flex">
          <div
            @click="charge"
            v-if="data.chargeName"
            style="cursor: pointer; color: red"
            :class="data.chargeName.length > 30 ? 'dade-text' : ''"
          >
            {{ data.chargeName }}
          </div>
          <div
            @click="charge_del"
            v-if="data.chargeName"
            style="cursor: pointer; margin-left: 10px"
          >
            取消选择
          </div>
          <div @click="charge" v-else style="cursor: pointer">
            选择收费标准...
          </div>
        </div>
      </el-descriptions-item>

      <el-descriptions-item label="统计方式">
        <Space direction="vertical" size="large">
          <RadioGroup v-model="data.radio">
            <Radio label="1" style="font-weight: 500">按收费项目汇总</Radio>
            <Radio label="2" style="font-weight: 500">按小区汇总</Radio>
            <Radio label="3" style="font-weight: 500">按组团汇总</Radio>
            <Radio label="4" style="font-weight: 500">应收款明细表 - 按房产汇总</Radio>
            <Radio label="5" style="font-weight: 500">应收款明细表 - 按项目汇总</Radio>
          </RadioGroup>
        </Space>
      </el-descriptions-item>

      <el-descriptions-item label="房间状态">
        <div style="display: flex">
          <div
            @click="roomstatus"
            style="cursor: pointer; color: red"
            v-if="data.room"
            :class="data.room.length > 30 ? 'dade-text' : ''"
          >
            {{ data.room }}
          </div>
          <div
            @click="roomstatus_del"
            v-if="data.room"
            style="cursor: pointer; margin-left: 10px"
          >
            取消选择
          </div>
          <div @click="roomstatus" v-else style="cursor: pointer">
            选择房间状态...
          </div>
        </div>
      </el-descriptions-item>
    </el-descriptions>
    <!-- 房产 -->
    <house ref="house"></house>
    <!-- 收费项目 -->
    <Chargeitem ref="chargeitem" @chargeitemAll="chargeitemAll"></Chargeitem>
    <!-- 收费标准 -->
    <Charge ref="charges" @chargesAll="chargesAll"></Charge>
    <!-- 房间状态 -->
    <RoomStatus ref="roomstatu" @roomstatuAll="roomstatuAll"></RoomStatus>
    <!-- 弹窗选择用户 -->
    <Modal v-model="modal1" width="800" title="选择客户" @on-ok="roomUser">
      <div>
        <room-user
          style="height: 600px"
          ref="child"
          :house="house_1"
        ></room-user>
      </div>
    </Modal>
    <excel-task
      ref="ExcelTask"
      :excelTask="excelTask"
      :excelTaskId="excelTaskId"
      @close="closeExcelTask"
    />
  </div>
</template>

<script>
import ExcelTask from "@/components/common/excelTask";
import House from "@/components/Admin/Forms/common/SelectProjectHouse";
import Chargeitem from "@/components/Admin/Forms/common/Chargeitem";
import Charge from "@/components/Admin/Forms/common/Charge";
import RoomStatus from "@/components/Admin/Forms/common/RoomStatus";
export default {
  name: "FormsChargeSum",
  components: {
    "room-user": () => import("../Common/room-user.vue"),
    House,
    Chargeitem,
    Charge,
    RoomStatus,
    ExcelTask,
  },
  data() {
    return {
      data: {
        house_id: "",
        startDate: "",
        endDate: "",
        payStartDate: "",
        payEndDate: "",
        dayPayStartDate: "",
        dayPayEndDate: "",
        chargeitemID: "",
        chargeitemIDName: "",
        room: "",
        room_id: "",
        radio: "1",
        is_meter_charge: "0",
        house: "",
        user: "",
        user_id: "",
        userType: [],
        charge_id: "",
        chargeName: "",
        paymentId: [],
      },
      startDate: "",
      endDate: "",
      payStartDate: "",
      payEndDate: "",
      dayPayStartDate: "",
      dayPayEndDate: "",
      payment: [],
      excelTaskId: "",
      excelTask: false,
      modal1: false,
      house_1: "",
      loading: false,
    };
  },
  mounted() {
    // 加载结算方式
    this.$myhttp
      .get("admin/OrderPayment/index", {
        "Content-Type": "application/json",
      })
      .then((backdata) => {
        let payment = backdata.data.data;
        this.payment = payment;
      });
  },
  methods: {
    excelPost() {
      if (this.data.house_id == "") {
        this.$Message.error("房产不能为空");
        return false;
      }
      this.data.targetController = "ChargeSumController";
      if (this.data.radio == 1) {
        this.data.taskName = "收费汇总表（按收费项目汇总）";
        this.data.targetFunction = "excel1";
      } else if (this.data.radio == 2) {
        this.data.taskName = "收费汇总表（按小区汇总）";
        this.data.targetFunction = "excel2";
      } else if (this.data.radio == 3) {
        this.data.taskName = "收费汇总表（按组团汇总）";
        this.data.targetFunction = "excel3";
      }else if(this.data.radio == 4){
        this.data.taskName = "应收款明细表 - 按房产汇总";
        this.data.targetController = "ChargeSumHouse";
        this.data.targetFunction = "excel4";
      }else if(this.data.radio == 5){
        this.data.taskName = "应收款明细表 - 按项目汇总";
        this.data.targetController = "ChargeSumHouse";
        this.data.targetFunction = "excel5";
      }
      this.data.dayPayStartDate = this.dayPayStartDate / 1000;
      this.data.dayPayEndDate = this.dayPayEndDate / 1000;
      this.data.payStartDate = this.payStartDate / 1000;
      this.data.payEndDate = this.payEndDate / 1000;
      this.data.startDate = this.startDate / 1000;
      this.data.endDate = this.endDate / 1000;
      ERP.showLoading();
      this.$myhttp
        .post("admin/ExcelTask/addTask", this.data, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((backdata) => {
          // 异步执行成功后
          ERP.hideLoading();
          this.$store.commit("excelTaskAdd");
          this.$Message.success("创建导出任务成功");
          var data = backdata.data.data;
          this.excelTaskId = data.excelTaskId;
          this.openExcelTask();
        })
        .catch(function (error) {
          this.$Message.error("出错了");
          ERP.hideLoading();
        });
    },
    //选择客户
    user() {
      this.house_1 = "";
      this.modal1 = true;
    },
    roomUser() {
      let user = this.$refs.child.getUser();
      //console.log(user);
      if (user.id) {
        this.data.user_id = user.id;
        this.data.user = user.name;
      }
    },
    //选择房产
    houses() {
      let _this = this;
      this.$refs.house.show([], function (data) {
        //整理项目和房产ID
        _this.$myhttp
          .post("admin/common/house_tree_id", data, {
            "Content-Type": "application/x-www-form-urlencoded",
          })
          .then((backdata) => {
            // 异步执行成功后
            _this.data.house_id = backdata.data.house_ids;
            _this.data.house = backdata.data.ancestor_name;
            // _this.data.chargeitemID = "";
            // _this.data.chargeitemIDName = "";
            // _this.data.charge_id = "";
            // _this.data.chargeName = "";
          })
          .catch(function (error) {
            _this.$Message.error("选择房产失败");
          });
      });
    },
    houses_del() {
      this.data.house_id = "";
      this.data.house = "";
    },
    //选择收费项目
    chargeitems() {
      this.$refs.chargeitem.getInvo(this.data);
    },
    chargeitems_del() {
      this.data.chargeitemID = "";
      this.data.chargeitemIDName = "";
    },
    chargeitemAll() {
      let data = this.$refs.chargeitem.getReturn();
      this.data.chargeitemID = data
        .map((ret) => {
          return ret.id;
        })
        .join(",");
      this.data.chargeitemIDName = data
        .map((ret) => {
          return ret.label;
        })
        .join(",");
      this.data.charge_id = "";
      this.data.chargeName = "";
    },
    //选择收费标准
    charge() {
      this.$refs.charges.getInvo(this.data);
    },
    charge_del() {
      this.data.charge_id = "";
      this.data.chargeName = "";
    },
    chargesAll() {
      let data = this.$refs.charges.getReturn();
      this.data.charge_id = data
        .map((ret) => {
          return ret.id;
        })
        .join(",");
      this.data.chargeName = data
        .map((ret) => {
          return ret.label;
        })
        .join(",");
    },
    //房间状态
    roomstatus() {
      this.$refs.roomstatu.getInvo(this.data);
    },
    roomstatus_del() {
      this.data.room_id = "";
      this.data.room = "";
    },
    roomstatuAll() {
      let data = this.$refs.roomstatu.getReturn();
      this.data.room_id = data
        .map((ret) => {
          return ret.id;
        })
        .join(",");
      this.data.room = data
        .map((ret) => {
          return ret.label;
        })
        .join(",");
    },
    openExcelTask() {
      this.$store.commit("excelTaskClear");
      this.excelTask = true;
      this.$refs.ExcelTask.change(1);
    },
    closeExcelTask() {
      this.excelTask = false;
    },
  },
};
</script>

<style>
@import "../../../assets/css/table.css";

.ti {
  margin: 1%;
  width: 98%;
}

.text1 {
  text-align: center;
}

.pages {
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}

.search {
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}

.text2 {
  color: rgb(250, 248, 248);
}

.kuan {
  width: 10%;
}

.zhanwu {
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}

.cdj_margin {
  margin-left: 1px;
}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.dade-text {
  width: 300px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.d-flex-right {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Forms/chargeSum.vue